import React from 'react';
import { Share2, MessageCircle, Instagram } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { toast } from '../hooks/use-toast';
import { logError } from '../lib/logError';

export const trackHomeEvent = (kind) => {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/events/home`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ kind }),
    keepalive: true,
  }).catch(() => {});
};

const SITE_URL = 'https://www.tecnicheperfette.com';

const buildText = (date) => {
  const formatted = new Date(`${date}T12:00:00`).toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });
  return `Segna la data: ${formatted} Finale Nazionale TECNICHE PERFETTE, il primo torneo di freestyle italiano! ${SITE_URL}`;
};

const ShareCountdownButton = ({ date }) => {
  const text = buildText(date);

  const shareWhatsApp = () => {
    trackHomeEvent('share_whatsapp');
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener,noreferrer');
  };

  const shareInstagram = async () => {
    trackHomeEvent('share_instagram');
    if (navigator.share) {
      try {
        await navigator.share({ title: 'Finale Nazionale Tecniche Perfette', text, url: SITE_URL });
        return;
      } catch (e) { logError('[share] condivisione nativa annullata o fallita, uso il fallback', e); }
    }
    try {
      await navigator.clipboard.writeText(text);
      toast({ title: 'Testo copiato!', description: 'Incollalo nella tua Storia Instagram.' });
    } catch {
      toast({ title: 'Condividi su Instagram', description: text });
    }
    window.open('https://www.instagram.com/', '_blank', 'noopener,noreferrer');
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="share-countdown-btn"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gray-900 hover:bg-gray-800 text-white font-bold text-sm sm:text-base shadow-xl transition-transform hover:scale-105 border border-gray-600"
          style={{ fontFamily: 'Oswald, sans-serif', letterSpacing: '0.5px' }}
        >
          <Share2 size={18} />
          CONDIVIDI
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="bg-gray-900 border-gray-700 text-white min-w-[220px]">
        <DropdownMenuItem onClick={shareWhatsApp} data-testid="share-whatsapp-btn" className="flex items-center gap-2 cursor-pointer focus:bg-gray-800 focus:text-white">
          <MessageCircle size={15} className="text-green-500" /> WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={shareInstagram} data-testid="share-instagram-btn" className="flex items-center gap-2 cursor-pointer focus:bg-gray-800 focus:text-white">
          <Instagram size={15} className="text-pink-500" /> Instagram Stories
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ShareCountdownButton;
